<template>
	<div class='load-abris-block'>
		<div>
			<label>
				<span class='custom-load-input'>Загрузить координаты (.gpx .kml)</span>
				<input style='display: none;' ref='coord-file-input' type='file' @input='onFileInput' accept='.gpx,.kml' :disabled='!actLpoIsDraft'>
			</label>
		</div>

		<CustomModal ref='modal-loaded-coords'>
			<table class='coord-table'>
				<thead>
					<tr>
						<th>№</th>
						<th>lat</th>
						<th>lon</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for='(coord, i) in coordList'>
						<td>{{ i + 1 }}</td>
						<td>{{ coord.lat }}</td>
						<td>{{ coord.lon }}</td>
					</tr>
				</tbody>
			</table>

			<button @click='save'>Сохранить</button>

		</CustomModal>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	const LOAD_COORDINATES = process.env.VUE_APP_ROOT_API + 'load_file/load_coordinates.php';

	export default {
		name: 'LoadAbrisBlock',
		data: () => ({
			// scale: 10000,
			coordList: [],
		}),

		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },
		},

		methods: {
			save() {
				this.addPointList(this.coordList).then(res => {
					this.updatePointList();
					this.closeModal();
				});
			},

			openModal() {
				this.$refs['modal-loaded-coords'].open();
			},
			closeModal() {
				this.$refs['modal-loaded-coords'].close();
			},

			onFileInput() {
				this.loadFile();
			},
			loadFile() {
				
				const inputFile = this.$refs['coord-file-input'].files[0];

				if (!inputFile) {
					this.$toast.add({severity: 'warn', detail: 'Файл не выбран', life: 10000});
					return;
				}

				const form = new FormData();

				form.append('coord_file', inputFile);

				fetch(LOAD_COORDINATES, {
					credentials: 'include',
					method: 'post',
					body: form,
				})
				.then(res => res.json())
				.then(res => {

					this.coordList = res;
					this.openModal();

				})
				.catch(err => {
					throw err;
				})
				.finally(() => {
					this.$refs['coord-file-input'].value = null;
				});
			},

			...mapActions('selectedLpo', [
				'addPointList',
				'updatePointList'
			])
		}
	};
</script>

<style scoped>

	.abris-exists-text {
		color: green;
	}

	.custom-load-input {
		border-radius: 5px;
		display: inline-block;
		padding: 4px 14px;
		background-color: black;
		color: white;
		cursor: pointer;
		margin: 10px 0 20px 0;
	}

	.scale-block {
		margin-top: 10px;
	}


	.coord-table td {
		border: 1px solid black;

		padding: 4px 10px;
	}
</style>